import React from "react";

import logo from "../assets/fetch-logo.svg"
import style from "./PlaceholderPage.module.scss"

const PlaceholderPage: React.FC = () => {
  return (
    <div className={style.container}>
      <div className={style.main}>
        <div className={style.text}>Coming Soon...</div>
      </div>
      <img src={logo} alt="Fetch Logo" className={style.logo}/>
    </div>
  );
}

export default PlaceholderPage;
